import moment = require("moment");

export function convertDateTimeToFormat(date?: Date | string, invalidDateReturn = undefined, format: string = 'MM/DD/YYYY') {
    if (date) {
        var m = moment(date);
        return m.isValid() ? m.format(format) : invalidDateReturn;
    }
    return invalidDateReturn;
}

export function removeTimeAndTimezoneFromDate(selectedDate: Date) {
    return new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()));
}
